<template>
  <div class="news_module">
    <div class="mainTitle">企业动态</div>
    <div class="subSpace subTitle">
      <span class="mSubStl ">Company</span>
      <span class="mianColo">&nbsp;News</span>
    </div>
    <div class="news_bag">
      <div class="news_cup">
        <div v-for="(news,index) in homeNewsList1" :key="index">
          <div @click="checkNews(news.newsId)" class="h_news_img">
            <img :src="news.path" width="125" height="93" alt="">
          </div>
          <div class="h_news_tips">
            <div class="h_news_title" @click="checkNews(news.newsId)">{{news.newsTitle}}</div>
            <div class="h_news_content"> {{news.newsTip}} </div>
          </div>
        </div>
      </div>
      <div class="news_cup">
        <div v-for="(news,index) in homeNewsList2" :key="index">
          <div @click="checkNews(news.newsId)" class="h_news_img">
            <img :src="news.path" width="125" height="93" alt="">
          </div>
          <div class="h_news_tips">
            <div class="h_news_title" @click="checkNews(news.newsId)">{{news.newsTitle}}</div>
            <div class="h_news_content"> {{news.newsTip}} </div>
          </div>
        </div>
      </div>
    </div>
    <div class="news_check_more">
      <el-button @click="seeNewsSpace" class="more_btn">
        查看更多&nbsp;&nbsp;<i class="el-icon-right more_icon"></i>
      </el-button>
    </div>
  </div>
</template>
<script>
import { newsList } from '@/api/frontApi/news';
export default {
  data() {
    return {
      homeNewsList1: [],
      homeNewsList2: [],
      defaultPath: '../../../static/img/blank.jpg'
    };
  },
  created() {
    this.getHomeNews();
  },
  methods: {
    getHomeNews() {
      this.homeNewsList1 = [];
      this.homeNewsList2 = [];
      let tempArr = [];
      newsList({ pageNo: 1, pageSize: 6 }).then(res => {
        res.data.list.forEach(item => {
          let temp = { newsId: '', newsTitle: '', newsTip: '', path: '' };
          temp.newsId = item.newsId;
          temp.newsTitle = item.newsTitle;
          temp.newsTip = item.newsSmBody;
          if (item.picMain) temp.path = item.picMain;
          else temp.path = this.defaultPath;
          tempArr.push(temp);
        });
        this.homeNewsList1 = tempArr.slice(0, 3);
        this.homeNewsList2 = tempArr.slice(3, 6);
      });
    },
    checkNews(newsId) {
      this.$router.push({
        name: 'newsInfo',
        params: {
          newsId: newsId
        }
      });
    },
    seeNewsSpace() {
      this.$router.push({ name: 'news' });
    }
  }
};
</script>
<style lang="stylus" scoped>
.news_module {
  padding: 10px 0;
  color: #000;
  width: 100%;

  .news_bag {
    width: 70%;
    min-width: 960px;
    margin: 0 auto;
    overflow: hidden;

    .news_cup {
      float: left;
      width: 49%;

      .h_news_img {
        width: 23%;
        min-width: 120px;
        height: 100px;
        float: left;
      }

      .h_news_tips {
        float: left;
        width: 70%;
        min-width: 300px;
        padding: 3px 10px;
        overflow: hidden;
        height: 100px;

        .h_news_content {
          overflow: hidden;
          color: #515151;
          height: 60px;
          font-size: 14px;
          line-height: 20px;
          width: 100%;
          min-width: 290px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3; /* 第10行显示 ... */
          -webkit-box-orient: vertical;
        }

        .h_news_title {
          font-size: 16px;
          height: 25px;
          width: 100%;
          min-width: 290px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1; /* 第10行显示 ... */
          -webkit-box-orient: vertical;
        }

        .h_news_title:hover {
          color: #0e6184;
          cursor: pointer;
        }
      }
    }
  }
}

.news_check_more {
  width: 100%;
  text-align: center;
}

.help_space {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/home/homeNews.vue